<template>
    <div class="animated fadeIn vld-parent custom-100">
        <b-row>
            <b-col sm="12">
                <searchBar ref="searchBar" :user-groups="userGroups"
                           :user-group-select="userGroupSelect" :on-search="queryData"></searchBar>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <anfragenTable ref="auftraegeTable"
                               :table-data="data"
                               :all-groups="allGroups"></anfragenTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import searchBar from './search_bar'
    import anfragenTable from './anfragen_table'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

    export default {
        name: "AnfragenInWork",
        components: {'searchBar':searchBar, 'anfragenTable': anfragenTable},
        data() {
            return {
                loader: undefined,
                // SearchbarProps
                userGroups: [],
                userGroupSelect: undefined,
                data: [],
                currentPage: 1,
                settings: {fg_stufe1: false},
                allGroups: {},
            }
        },
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/auftragsbuch/data/fetch_anfragen'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {

            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    let module_groups = response.body.data.module_groups;

                    this.userGroups.push({text: "Alle", value: {id: "all", module: "all"}});
                    this.userGroupSelect = {id: "all", module: "all"};
                    for (let i = 0; i < module_groups.length; i++) {
                        let res = JSON.parse(sessionStorage.getItem(module_groups[i].name));
                        if (res !== null) {
                            this.userGroups.push({text: res.username, value: module_groups[i]});
                        } else {
                            switch (module_groups[i].module) {
                                case "ab":
                                    module_groups[i].name += " (Auftragsbuch)";
                                    break;
                                case "mm":
                                    module_groups[i].name += " (Mängelmelder)";
                                    break;
                            }
                            this.userGroups.push({text: module_groups[i].name, value: module_groups[i]});
                        }
                    }

                    this.allGroups = response.body.data.all_groups;
                    this.queryData("A", {id: "all", module: "all"}, -1, "");
                } else {
                    window.location = Redirect_500;
                }
            },
            responseOkFetch(response) {
                this.hideLoader();
                this.$refs.auftraegeTable.currentPage = 1;
                this.$refs.searchBar.onFirstSearch();
                if (response.status === 200 && response.body.status === "ok") {
                    this.data = response.body.data;
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            queryData(typ, group, year, searchText, count, augr) {
                let module = "";
                module = group.module;
                group = group.id;

                this.showLoader();
                this.$http.get(
                    Server_URL+'/auftragsbuch/data/fetch_anfragen/'+group+
                    "?search_typ="+typ+
                    "&search_text="+searchText+
                    "&year="+year+
                    "&offen=1"+
                    "&module=" + module
                ).then(this.responseOkFetch, this.responseError)
            }
        },
    }
</script>

<style scoped>

</style>
